import MutualLoginResult from '../result/MutualLoginResult';
import ServerFacade from '../network/ServerFacade';
import MutualLoginRequest from '../request/MutualLoginRequest';

/**
 *  This class acts as an interface to log in a user
 *  It also has a method to parse the information contained in the photos
 *  belonging to a user
 */

class MutualLoginDAO {
	/**
	 *  Takes a MutualLoginRequest and creates a MutualLoginResult
	 */
	static async loginUser(request: MutualLoginRequest): Promise<MutualLoginResult> {
		const response = await ServerFacade.loginUser(request);
		try {
			return new MutualLoginResult(
				true,
				'Logged In',
				response.id,
				response.first_name,
				response.last_name,
				response.p_enabled,
			);
		} catch {
			return new MutualLoginResult(
				false,
				'Error logging in',
				'-1',
				'none',
				'none',
				false,
			);
		}
	}
}

export default MutualLoginDAO;
